import { useMemo } from 'react';

import { FilterRendererMap, FilterType } from './DataTable.types';
import { MultiSelectFilterRenderer, RangeFilterRenderer, DateRangeFilterRenderer } from './components/FilterRenderers';

const DEFAULT_FILTER_RENDERERS: FilterRendererMap = {
    [FilterType.MULTI_SELECT]: MultiSelectFilterRenderer,
    [FilterType.DATE_RANGE]: DateRangeFilterRenderer,
    [FilterType.RANGE]: RangeFilterRenderer,
};

const useFilterRenderers = (customRenderers?: FilterRendererMap): FilterRendererMap => {
    return useMemo(() => {
        return {
            ...DEFAULT_FILTER_RENDERERS,
            ...customRenderers,
        };
    }, [customRenderers]);
};

export default useFilterRenderers;
